/* eslint-disable */
/* prettier-ignore */
import * as utils from '../utils'

export default {
  prefix: 'cus',
  iconName: 'truck',
  icon: [
    480, // width
    480, // height
    [],
    null,
    `
      M88,312c-13.255,0-24,10.745-24,24s10.745,24,24,24s24-10.745,24-24S101.255,312,88,312z M88,344c-4.418,0-8-3.582-8-8
      s3.582-8,8-8s8,3.582,8,8S92.418,344,88,344z
      
      M216,312c-13.255,0-24,10.745-24,24s10.745,24,24,24s24-10.745,24-24S229.255,312,216,312z M216,344c-4.418,0-8-3.582-8-8
      s3.582-8,8-8s8,3.582,8,8S220.418,344,216,344z
      
      M392,312c-13.255,0-24,10.745-24,24s10.745,24,24,24s24-10.745,24-24S405.255,312,392,312z M392,344c-4.418,0-8-3.582-8-8
      s3.582-8,8-8s8,3.582,8,8S396.418,344,392,344z
      
      M479.2,172.424l-32-64c-1.362-2.725-4.153-4.441-7.2-4.424H304V80c0-4.418-3.582-8-8-8H8c-4.418,0-8,3.582-8,8v256
			c0,4.418,3.582,8,8,8h24.64c4.391,30.574,32.736,51.8,63.311,47.409c24.574-3.529,43.88-22.836,47.409-47.409h17.28
			c4.391,30.574,32.736,51.8,63.311,47.409c24.574-3.529,43.88-22.835,47.409-47.409h65.28c4.391,30.574,32.736,51.8,63.311,47.409
			c24.574-3.529,43.88-22.836,47.409-47.409H472c4.418,0,8-3.582,8-8V176C480.014,174.762,479.74,173.538,479.2,172.424z M88,376
			c-22.091,0-40-17.909-40-40c0-22.091,17.909-40,40-40s40,17.909,40,40C127.974,358.081,110.08,375.974,88,376z M216,376
			c-22.091,0-40-17.909-40-40c0-22.091,17.909-40,40-40s40,17.909,40,40C255.974,358.081,238.08,375.974,216,376z M288,328h-16.64
			c-4.391-30.575-32.736-51.8-63.311-47.409c-24.574,3.529-43.88,22.835-47.409,47.409h-17.28
			c-4.391-30.575-32.736-51.8-63.311-47.409C55.475,284.12,36.169,303.426,32.64,328H16v-64h272V328z M288,248H16V88h272V248z
			 M392,376c-22.091,0-40-17.909-40-40c0-22.091,17.909-40,40-40c22.091,0,40,17.909,40,40C431.974,358.081,414.08,375.974,392,376z
			 M464,264h-16v-16h16V264z M464,232h-24c-4.418,0-8,3.582-8,8v32c0,4.418,3.582,8,8,8h24v48h-16.64
      c-4.391-30.575-32.736-51.8-63.311-47.409c-24.574,3.529-43.88,22.835-47.409,47.409H304V120h131.056L464,177.888V232z
      
      M439.2,172.424l-16-32c-1.362-2.725-4.153-4.441-7.2-4.424h-88c-4.418,0-8,3.582-8,8v64c0,4.418,3.582,8,8,8h104
      c4.418,0,8-3.582,8-8v-32C440.014,174.762,439.74,173.538,439.2,172.424z M424,200h-88v-48h75.056L424,177.888V200z
      
      M360,232h-32c-4.418,0-8,3.582-8,8s3.582,8,8,8h32c4.418,0,8-3.582,8-8S364.418,232,360,232z

      M120,136H40c-4.418,0-8,3.582-8,8s3.582,8,8,8h80c4.418,0,8-3.582,8-8S124.418,136,120,136z

      M152,168H72c-4.418,0-8,3.582-8,8s3.582,8,8,8h80c4.418,0,8-3.582,8-8S156.418,168,152,168z

      M264,104c-4.418,0-8,3.582-8,8v16c0,4.418,3.582,8,8,8s8-3.582,8-8v-16C272,107.582,268.418,104,264,104z

      M264,152c-4.418,0-8,3.582-8,8v64c0,4.418,3.582,8,8,8s8-3.582,8-8v-64C272,155.582,268.418,152,264,152z

      M352,392c-8.837,0-16-7.163-16-16c0-4.418-3.582-8-8-8s-8,3.582-8,8c0,17.673,14.327,32,32,32c4.418,0,8-3.582,8-8
			S356.418,392,352,392z
      
      z
    ` // svg path data
  ]
}



// WEBPACK FOOTER //
// ./src/components/icon/custom-icons/custom-icons/truck.js